import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

export function IsNlpEnabled(): boolean {
  const sessionManagementService = getSessionManagementServiceInstance();
  return sessionManagementService.isNlpServiceEnabled();
}

